module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ManageStoreButtonText":"My Store"},"th":{"ManageStoreButtonText":"ร้านค้าของฉัน"}}')
  delete Component.options._Ctor
}
